/** Node.js environment values (matches `process.env.NODE_ENV`). */
export const NODE_ENV = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  TEST: 'test',
} as const;
